export default __webpack_public_path__ + "static/media/orange-vaccine.05dc0bb8.svg";